import React, { Component } from "react";
import { Link } from "react-router-dom";

interface AllProps {
  match: any;
  history: any;
}

export default class SearchBox extends Component<AllProps> {
  state = {
    searchLabel: "file_name",
    searchValue: "",
    searchTimeout: 0,
  };

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  handleChange = (e: any) => {
    this.setState({ searchLabel: e.target.value });
  };

  handleChangeInput = (e: any) => {
    const searchValue = e.target.value;
    this.setState({ searchValue });

    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    const timeout = setTimeout(() => {
      if (searchValue.trim()) {
        this.navigateToSearch();
      }
    }, 500);

    this.setState({ searchTimeout: timeout });
  };

  handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.state.searchTimeout) {
        clearTimeout(this.state.searchTimeout);
      }
      this.navigateToSearch();
    }
  };

  navigateToSearch = () => {
    const { searchLabel, searchValue } = this.state;

    if (!searchLabel || !searchValue || !searchValue.trim()) return;

    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    // Encode the search value to handle special characters like /
    const encodedSearchValue = encodeURIComponent(searchValue.trim());

    // Construct the URL based on search type
    const searchUrl = searchLabel === "vetting"
      ? `/vetting-results/${searchLabel}/${encodedSearchValue}`
      : `/search-results/${searchLabel}/${encodedSearchValue}`;

    this.props.history.push(searchUrl);
  };

  render() {
    const { searchLabel, searchValue } = this.state;
    const isSearchDisabled = !searchLabel || !searchValue || !searchValue.trim();

    return (
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title">
                <div className="main-search open">
                  <div className="input-group">
                    <input
                      type="text"
                      name="searchValue"
                      className="form-control"
                      value={searchValue}
                      placeholder="Search . . ."
                      onChange={e => this.handleChangeInput(e)}
                      onKeyPress={this.handleKeyPress}
                      style={{ width: "150px" }}
                      autoComplete="off"
                    />
                    <a
                      className="dropdown-toggle input-group-append"
                      href="#"
                      data-toggle="dropdown"
                    />

                    <div className="dropdown-menu dropdown-menu-right notification">
                      <ul className="pro-body list-unstyled">
                        {[
                          { label: "Phone Number", value: "phone" },
                          { label: "Email", value: "email" },
                          { label: "App Id", value: "app_id" },
                          { label: "File No", value: "file_name" },
                          { label: "Borrower Name", value: "borrower_name" },
                          { label: "Property Owner Name", value: "property_owner_name" },
                          { label: "Vetting No", value: "vetting" },
                        ].map((item) => (
                          <li key={item.value}>
                            <label>
                              <input
                                type="radio"
                                name="searchLabel"
                                value={item.value}
                                checked={searchLabel === item.value}
                                onChange={this.handleChange}
                              />
                              {item.label}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <button
                      className={`input-group-append search-btn btn btn-primary ${isSearchDisabled ? 'disabled' : ''}`}
                      onClick={this.navigateToSearch}
                      disabled={isSearchDisabled}
                      style={{
                        opacity: isSearchDisabled ? 0.6 : 1
                      }}
                    >
                      <i className="feather icon-search input-group-text" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}